import React, { useEffect, useState } from 'react'
import BasicCard from '../../../../../components/card/basiccard/BasicCard';
import { CardNumberElement, useElements, useStripe } from '@stripe/react-stripe-js';
import HorizontalSeparator from '../../../../../components/separator/horizontalSeparator/HorizontalSeparator';
import Button from '../../../../../components/button/Button';
import { BUTTON_TYPE } from '../../../../../components/button/constants';
import { useDispatch, useSelector } from 'react-redux';
import IconLabel from '../../../../../components/iconlabel/IconLabel';
import styles from "../../ManageCards.styles"
import { VEC_ICON_NAME } from '../../../../../components/icons/constants';
import { componentKey as manageCardsComponentKey, setLoadingState, setNewCardDetails } from '../../ManageCardsSlice';
import { COMMON_LOADING_STATES, PAGE_STATE } from '../../../../constants/constants';
import TextInput from '../../../../../components/input/textinput/TextInput';
import { addNotifications } from '../../../../toaster/ToasterPortalSlice';
import { addCardDetails, saveCardDetails } from '../../ManageCardsSaga';
import PaymentGatewayCardFields from '../../../../../components/paymentgatewaycardfields/PaymentGatewayCardFields';

export const AddNewCard = ({
    showAddNewCard = false,
    setShowAddNewCardCb = () => {}
}) => {

    const dispatch = useDispatch();
    const { newCardDetails } = useSelector(state => state[manageCardsComponentKey])

    const [nameOnCard, setNameOnCard] = useState("");
    const [emailAdrress, setEmailAdrress] = useState("");
    const [isProcessing, setIsProcessing] = useState(false);

    useEffect(() => {
        setNameOnCard("")
        setEmailAdrress("")
    }, [showAddNewCard])

    const stripe = useStripe();
    const elements = useElements();

    const handleCardDetailsChange = (event) => {
        dispatch(setNewCardDetails(event.complete))
    }

    const handleSubmit = async (event) => {
        event.preventDefault();

        try {
            setIsProcessing(true)
            dispatch(setLoadingState({ state: COMMON_LOADING_STATES.GENERAL_LOADING }))

            const { error, paymentMethod } = await stripe.createPaymentMethod({
                type: 'card',
                card: elements.getElement(CardNumberElement),
                billing_details: {
                    email: emailAdrress,
                    name: nameOnCard
                }
            });

            if (!error) {
                const { id, billing_details, card } = paymentMethod;
                const { address } = billing_details

                const cardDetails = {
                    paymentMethodId: id,
                    IsCardSave: true,
                    CommonContactEmail: emailAdrress,
                    CommonCardHolderName: nameOnCard,
                    CardNumber: card.last4,
                    CommonCreditCardNumber: card.last4,
                    CommonCity: address.city,
                    CommonState: address.state,
                    CommonCountry: address.country,
                    CommonZipcode: address.postal_code
                }
                dispatch(saveCardDetails(cardDetails))
            } else {
                dispatch(addNotifications({ heading: "Error with payment method", message: error?.message }))
            }
        } catch (error) {
            console.log('err:', error)

        } finally {
            setIsProcessing(false);
            dispatch(setLoadingState({ state: COMMON_LOADING_STATES.GENERAL_READY }));
        }
    };

    return (
        <>
            <div style={styles.actionButtons}>
                <IconLabel
                    onClickCb={() => setShowAddNewCardCb(!showAddNewCard)}
                    containerStyles={styles.iconLabelContainer}
                    text=" Add new card"
                    icon={VEC_ICON_NAME.CIRCULAR_PLUS_ICON}
                    labelStyles={styles.pointer}
                />
            </div>

            {showAddNewCard && <BasicCard customStyles={{ display: "block" }}>
                <PaymentGatewayCardFields handleCardDetailsChangeCb={handleCardDetailsChange} />
                <HorizontalSeparator style={{ margin: "20px 0px" }} />
                <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', paddingBottom: '30px'}}>
                    <TextInput
                        name='name'
                        label={'Name on card'}
                        placeHolder='Name'
                        type='text'
                        value={nameOnCard}
                        onChangeCb={(e) => setNameOnCard(e.target.value)}
                    />
                    <TextInput
                        name='name'
                        label={'Email Address'}
                        placeHolder='Email Address'
                        type='text'
                        value={emailAdrress}
                        onChangeCb={(e) => setEmailAdrress(e.target.value)}
                    />
                </div>

                <div style={styles.cardFormBtnContainer}>
                    <Button onClickCb={handleSubmit} style={styles.cardFormBtn} disabled={(!nameOnCard || !emailAdrress) || !newCardDetails || isProcessing}>Save</Button>
                    <Button type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER} onClickCb={() => setShowAddNewCardCb(false)} style={styles.cardFormBtn}>Cancel</Button>
                </div>

            </BasicCard>}
        </>
    )
}
